(function () {
    'use strict';
    
    angular
    .module('laekkerAI.tablet')
    .controller('FilterButtonController', [
        FilterButtonController
    ]);

    function FilterButtonController() {
        var $ctrl = this;
    
        $ctrl.$onInit = function () {
        };
    
        $ctrl.$onChanges = function(changes) {
        };
    
        $ctrl.$onDestroy = function () {
        };
    
    }
}());